import logo from './logo.svg';
import './App.css';
import { LoginPage } from './pages/LoginPage';
import PrincipalPage from './pages/PrincipalPage';
import { Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import { ActivosTipoPage } from './pages/catalogos/ActivosTipoPage';
import { ServiciosTipoPage } from './pages/catalogos/ServiciosTipoPage';
import { ActivosPage } from './pages/catalogos/ActivosPage';
import { UsuariosPage } from './pages/catalogos/UsuariosPage';
import { DireccionesPage } from './pages/catalogos/DireccionesPage';
import { AsuntosPage } from './pages/asuntos/AsuntosPage';
import { PrioridadesPage } from './pages/catalogos/PrioridadesPage';
import { CapitulosPage } from './pages/catalogos/CapitulosPage';
import { DepartamentosPage } from './pages/catalogos/DepartamentosPage';
import { ReporteFallasPage } from './pages/reportefallas/ReporteFallasPage';
import { ResumenFallasPage } from './pages/resumenfallas/ResumenFallasPage';
// import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  const {logueado} = useContext(AuthContext);


  return (
    <Routes>
    {
      !logueado ? (
        <>
          <Route path="/" element={<LoginPage />} /> 
          <Route name="/login" path="/" element={<LoginPage />} />
          <Route path="*" element={<LoginPage />} />
        </>
      )
      :
      (
        <>
        <Route name="home" path="/" element={<PrincipalPage />} >
          <Route exact path="/activosTipo" element={<ActivosTipoPage />} />
          <Route exact path="/serviciosTipo" element={<ServiciosTipoPage />} />
          <Route exact path="/activos" element={<ActivosPage />} />
          <Route exact path="/usuarios" element={<UsuariosPage />} />
          <Route exact path="/direcciones" element={<DireccionesPage />} />
          <Route exact path="/asuntos" element={<AsuntosPage />} />          
          <Route exact path="/prioridades" element={<PrioridadesPage />} />          
          <Route exact path="/capitulos" element={<CapitulosPage />} />          
          <Route exact path="/departamentos" element={<DepartamentosPage />} />          
          <Route exact path="/reportefallas" element={<ReporteFallasPage />} />          
          <Route exact path="/resumenfallas" element={<ResumenFallasPage />} />          
        </Route>
        </>
      )
    }
  </Routes>

  );
}

export default App;
